import { useSnackbar, type VariantType } from "notistack";

export type ToastInput = {
  title: string;
  description?: string;
  variant?: "default" | "destructive";
};

/**
 * Notistack-backed toasts (replaces Radix/shadcn toaster). Same call shape as before.
 */
export function useToast() {
  const { enqueueSnackbar } = useSnackbar();

  const toast = ({ title, description, variant }: ToastInput) => {
    const message = description ? `${title}: ${description}` : title;
    const v: VariantType = variant === "destructive" ? "error" : "info";
    enqueueSnackbar(message, { variant: v });
  };

  return { toast };
}
